module.exports = __webpack_public_path__ + "img/pay-logo-uniont.34731804.png";